import {LOGOUT_REQUEST} from '@redux/modules/session/types';

import * as types from './types';

const reducer = (
  state = {
    isFetching: false,
    list: [],
    error: null,
    locale: null,
    isFetchingPersonTypes: false,
    personTypesDict: {},
  },
  action,
) => {
  switch (action.type) {
    case types.PERSON_TYPES_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case types.PERSON_TYPES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: action.payload.data,
        locale: action.payload.locale,
      };

    case types.PERSON_TYPES_FAILURE:
      return {
        ...state,
        isFetching: false,
        list: [],
        error: action.error,
      };

    case types.PERSON_TYPES_DICT_REQUEST:
      return {...state, isFetchingPersonTypes: true};

    case types.PERSON_TYPES_DICT_SUCCESS:
      return {
        ...state,
        isFetchingPersonTypes: false,
        personTypesDict: {
          ...state.personTypesDict,
          [action.payload.clientId]: {
            [action.payload.locale]: action.payload.list,
          },
        },
      };

    case types.PERSON_TYPES_DICT_FAILURE:
      return {...state, isFetchingPersonTypes: false};

    case LOGOUT_REQUEST:
      return {
        ...state,
        isFetchingPersonTypes: false,
        personTypesDict: {},
      };

    default:
      return state;
  }
};

export default reducer;
